import _ from "lodash";
import { DATA_GRID_CELL_TYPES } from "../constants";

const getNumberCellProps = ({ node, cellConfig, customConfig }) => {
  const { property, showLoader } = customConfig || {};

  const value = _.get(node, property);

  if (value === undefined && showLoader) {
    return {
      cellType: DATA_GRID_CELL_TYPES.SKELETON,
    };
  }

  return {
    ...cellConfig,
    value: value || 0,
  };
};

export default getNumberCellProps;
